import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>Novedades de la versión</h3>

        <ul className="lista-cambios">
          <li>Se ha corregido la facturación a pacientes. Ya se pueden emitir facturas.</li>
          <li>En calendario, al crear una cita, ahora se puede elegir clínica.</li>
          <li>Descuentos por financiación ahora se pueden reflejar en el historial económico.</li>
          <li>Nueva tabla de tratamientos con alta de nuevos tratamientos.</li>
          <li>Imágenes por paciente desde el historial del paciente.</li>
          <li>Mejoras generales de uso en el historial de pacientes.</li>
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Introducir las citas en el calendario de la aplicación (no Google Calendar).</li>
          <li>Para tratamientos por piezas, usar el odontograma siempre que sea posible.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
